import look1 from "../../assets/images/bags/1.jpg";
import look2 from "../../assets/images/bags/2.jpg";
import look3 from "../../assets/images/shoes/1.jpg";
import look4 from "../../assets/images/shoes/2.jpg";

const gallery = [
  {
    image: look1,
    alt: "Silhouette contemporaine",
    className: "md:mt-0",
  },
  {
    image: look2,
    alt: "Elegance urbaine",
    className: "md:mt-16",
  },
  {
    image: look3,
    alt: "Details raffines",
    className: "md:mt-8",
  },
  {
    image: look4,
    alt: "Essentiels intemporels",
    className: "md:mt-24",
  },
];

export default function ApproachSection() {
  return (
    <section className="section-divider px-4 py-16 md:px-8 lg:px-10 lg:py-24">
      <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-[0.95fr_1.05fr]">
        <div className="surface-panel rounded-[34px] p-6 md:p-8 lg:p-10">
          <p className="brand-eyebrow">Notre univers</p>
          <h2 className="brand-display mt-4 text-4xl font-bold leading-tight text-[#21140f] md:text-6xl">
            De la mode pensee pour vous faire briller.
          </h2>
          <p className="mt-6 text-base leading-8 text-[#735d51]">
            Chez Si’Bella, nous aimons les pieces qui allient charme, style et
            femininite. Chaque selection est pensee pour vous aider a composer
            des looks qui marquent les esprits.
          </p>

          <div className="mt-10 grid gap-4">
            <div className="rounded-[24px] bg-[#241712] px-6 py-5 text-[#fff4ea]">
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#e6c8b4]">
                Style
              </p>
              <p className="mt-3 text-sm leading-7">
                Des details soignes, des teintes chaleureuses et une ambiance
                mode qui donnent envie de decouvrir toute la collection.
              </p>
            </div>
            <div className="rounded-[24px] bg-[#f0ddce] px-6 py-5 text-[#3c261b]">
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#8f654e]">
                Service
              </p>
              <p className="mt-3 text-sm leading-7">
                Une boutique simple a parcourir et une commande facile pour
                passer de l’envie au plaisir en quelques instants.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {gallery.map((item) => (
            <div
              key={item.alt}
              className={`surface-card overflow-hidden rounded-[30px] p-3 ${item.className}`}
            >
              <img
                src={item.image}
                alt={item.alt}
                className="h-full min-h-[280px] w-full rounded-[24px] object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
